import React from 'react'
import { Link } from 'react-router-dom'
import { translations } from '../../utils/constants'
import { useLocation, useHistory } from 'react-router-dom/'
import { useDispatch, useSelector } from 'react-redux'
import allPaths from '../../Config/paths'
import { TbLogout2 } from 'react-icons/tb';
import { FaUserAlt } from 'react-icons/fa';
import { handleLogout } from '../../utils/helpers';
import { Tooltip } from 'antd'
import { getMenuGroups, isMenuItemActive } from './menuConfig'

const SideMenu = (props) => {
    const { collapsed } = props
    const location = useLocation()
    const dispatch = useDispatch()
    const history = useHistory()
    const language = useSelector((state) => state.languageReducer?.language)
    const user = useSelector(state => state?.authReducer?.user)

    const handleLogoutButton = () => {
        handleLogout(history, dispatch);
        history.push(allPaths?.LOGIN);
    }

    const menuGroups = getMenuGroups({ language, user })

    const truncateText = (text, maxLength) => {
        if (text?.length > maxLength) {
            return text.substring(0, maxLength) + '...'
        }
        return text
    }

    return (
        <div className={`sidebar-menu ${collapsed ? 'collapsed' : ''}`}>
            <div>
                <div
                    className="user-info user-info-link"
                    role="button"
                    title={translations[language]?.viewProfile}
                    onClick={() => history.push(allPaths?.SETTINGS)}
                >
                    <div className="user-logo">
                        <Tooltip title={user?.email} placement="right">
                            {user?.profileImage ? (
                                <img src={user.profileImage} alt={user?.username || 'user'} className="user-logo-img" />
                            ) : (
                                user?.username ? user?.username.charAt(0).toUpperCase() : "U"
                            )}
                        </Tooltip>
                    </div>

                    {!collapsed && (
                        <Tooltip title={user?.email} placement="bottom">
                            <div className="user-details">
                                <p className="user-name capitalized-name truncate-text">
                                    {truncateText(user?.username, 13)}
                                </p>
                                <p className="user-email truncate-text">
                                    {truncateText(user?.email, 13)}
                                </p>
                            </div>
                        </Tooltip>
                    )}
                </div>
            </div>

            <div className='sidebar-nav'>
                {menuGroups.map((group, gi) => (
                    <div className='menu-group' key={group.key}>
                        {/* Collapsed rail: label hides, a thin divider marks the group boundary. */}
                        {gi > 0 || !collapsed ? (
                            <div className='menu-group-label' aria-hidden={collapsed}>
                                <span className='menu-group-label-text'>{group.label}</span>
                            </div>
                        ) : null}
                        {group.items.map((v, i) => {
                            const isActive = isMenuItemActive(v, location?.pathname)
                            return (
                                <Tooltip
                                    key={`${group.key}-${i}`}
                                    title={collapsed ? v.title : ""}
                                    placement="right"
                                >
                                    <div className={`menu-item ${isActive ? 'active' : ''}`}>
                                        <Link to={v?.route} className='menu-link'>
                                            <div className={`menu-icon-box ${isActive ? 'active-icon-box' : ''}`}>
                                                {v.icon && <span className='menu-icon'>{v.icon}</span>}
                                            </div>
                                            <span className={`menu-title ${collapsed ? 'hidden' : ''}`}>
                                                {v.title}
                                            </span>
                                        </Link>
                                    </div>
                                </Tooltip>
                            )
                        })}
                    </div>
                ))}
            </div>

            <div className='header-icon sidebar-logout' role='button' aria-label='User'>
                {user ? (
                    <Tooltip title={collapsed ? translations[language]?.logout : ""} placement="right">
                        <span className="header-signout" onClick={handleLogoutButton}>
                            <TbLogout2 className="logout-icon" size={20} />
                            {!collapsed && (
                                <span className="logout-text">{translations[language]?.logout}</span>
                            )}
                        </span>
                    </Tooltip>
                ) : (
                    <span
                        className='header-signin'
                        onClick={() => {
                            history.push(allPaths?.LOGIN);
                        }}
                    >
                        <FaUserAlt style={{ marginRight: '8px' }} />
                        {translations[language]?.signIn}
                    </span>
                )}
            </div>
        </div>
    )
}

export default SideMenu
